import {IMatchSeparator} from '../Tabs/Match/matchRibbon';
import Translator from '../../requests/apa/Translator';
import Utils from '../../utils/Utils';
import store from './../../store';
import { playFullMedia} from '../../actions/playmedia';
import { MESES, DIAS, MATCHDETAILINFO, E } from './constants';
import { MatchDate, Team } from '../requests/interfaces';


export const getSeparators = (): IMatchSeparator  => {
    return {
      pipe : Translator.get('matches_result_separatorPipe_label','|'),
      versus : Translator.get('matches_result_separatorVersus_label','VS'),
      versusdetail : Translator.get('match_detail_separatorVersus_label','vs.'),
      hyphen: Translator.get('matches_result_hyphen_label','-')
    }
}

export const getDayOffWeek = (d : Date): string => {
  const weekday = ["Domingo","Lunes","Martes","Miercoles","Jueves","Viernes","Sábado"];
  return weekday[d.getDay()];
}

export const getMonthName = (n: number): string => {
  const month = ["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"];
  return month[n];
}

export const isScheduled = (data : any) :boolean => {
  const {awayTeam : {logo: awayLogo}, homeTeam: {logo: homeLogo}} = data;

  return !(Utils.isNullOrUndefined(awayLogo) || awayLogo === '' || Utils.isNullOrUndefined(homeLogo) || homeLogo ==='');
}

export const getApaMatchLiveButton = () : {enable: true, group_id: string} => {
  const match_live_button = Utils.getApaMetadataKey('match_live_button','{"enable": false, "group_id": ""}') 
  const {enable, group_id } = match_live_button || {};
  return {
    enable, 
    group_id
  };
}

/*
  match_utc_offset = {
    default: { 
      offset: 0 
    },
    mexico: { 
      offset: -1
    },
    argentina: { 
      offset: -3
    },
  }
*/
export const getApaMatchUtcOffset = () => {
  const match_utc_offset = Utils.getApaMetadataKey('match_utc_offset','{"offset": 0}') 
  let { offset } = match_utc_offset || {};
  if(isNaN(offset)) offset = 0;

  return offset;
}

export const getApaAlertAutoHideTime = (): number => {
  const {qatar2022 = 6} = Utils.getApaMetadataKey('alert_autoHideTime','{"qatar2022": "12"}'); 
  return parseInt(qatar2022, 10) * 1000;
}

export const playWorldCupChannel = (gid: string): void => {

  const newChannel = {
    playerstate: 'PLAYING',
    source: {
      videoid: gid
    },
    size: {
      top: 0,
      left: 0,
      width: 1280,
      height: 720,
    },
    ispreview: false,
    islive: true,
    ispip: false,
    event: null,
    //payway_token,
  };

  store.dispatch(playFullMedia(newChannel));
}

export function getFullDate(d: MatchDate){
  return `${d.weekday}${','} ${d.day} ${'de'} 
    ${MESES[d.month - 1]} ${'|'} ${d.hours}${':'}${d.minutes} ${'hs'}`
}

export function getStatusPlay(currentPeriod: any, scheduledStartTimeUTC: any){
  switch (currentPeriod) {
    case undefined:
      return getFullDate(scheduledStartTimeUTC);
    default:
      return Translator.get(`${MATCHDETAILINFO}${currentPeriod}`) ;
  }
}


export function isTeamPlaceholder(team: Team): boolean {
  const notHasFlag = team.flag === undefined || team.flag.trim() === '';
  const teamName = team.name.toLowerCase();
  return notHasFlag && (
    teamName.includes("ganador") || 
    teamName.includes("perdedor") ||
    teamName.includes("winner") ||
    teamName.includes("loser") || 
    teamName.includes("second") || 
    teamName.includes("segundo")
    )
}


// WEBPACK FOOTER //
// ./src/mundial/utls/utils.ts